
import * as React from 'react';

interface VideoPlayerProps {
    YouTubeUrl: string
}

const VideoPlayer: React.FC<VideoPlayerProps> = (props) => {
    
    const [videoId, setVideoId] = React.useState<string>('');
    const [imageUrl, setImageUrl] = React.useState<string>('');
    const [playingVideo, setPlayingVideo] = React.useState<boolean>(false);

    React.useEffect(() => {
        const match = props.YouTubeUrl.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/);

        if( match && match[7].length == 11 ) {
            setVideoId(match[7]);
            setImageUrl(`https://i.ytimg.com/vi/${match[7]}/hqdefault.jpg`);
            // setImageUrl(`https://img.youtube.com/vi/${match[7]}/maxresdefault.jpg`);
        }
    }, []);
    
    return (
        <>
            {playingVideo && (
                <div className="relative aspect-video">
                    <iframe
                        className="w-full h-full absolute"
                        src={`https://www.youtube.com/embed/${videoId}?showinfo=0&autoplay=1`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />                    
                </div>

            )}

            {!playingVideo && (
                <div className={`aspect-video bg-center bg-cover bg-no-repeat relative`} style={{ backgroundImage: `url(${imageUrl})` }}>
                    <button type="button" onClick={() => setPlayingVideo(true)} className='absolute inset-0 flex items-center justify-center text-white font-bold text-7xl hover:text-red-primary'>
                        <span className="icon-play" aria-hidden="true"></span>
                        <span className='sr-only'>Spill av video</span>
                    </button>
                </div>
            )}
        </>
    );
};

export default VideoPlayer;
